import React from 'react';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { ValidationWrapper, ValidationWrapperCommonProps } from 'components/inputs/Validation/ValidationWrapper';
import { getEditorValidationSummary } from 'utils/ValidationUtils';
// import './EditorValidationWrapper.less'

interface IEditorValidationWrapperProps extends ValidationWrapperCommonProps {
  editor: IPropertyChild;
  children: React.ReactNode;
  shouldShow?: boolean;
}

/**
 * A Validation Wrapper that knows how to get the data for an editor.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function EditorValidationWrapper(props: IEditorValidationWrapperProps) {
  const validation = getEditorValidationSummary(props.editor);
  return <ValidationWrapper {...props} validation={validation} />;
}
